const BOT_ID_STORAGE_KEY = "tg_miniapp_bot_id"

// Утилита для получения bot_id из URL, Telegram WebApp и sessionStorage
export class BotConfig {
  static parseBotId(value) {
    if (value == null || value === "") {
      return null
    }

    const botId = parseInt(String(value), 10)
    return Number.isNaN(botId) ? null : botId
  }

  static getBotIdFromUrl() {
    const searchParams = new URLSearchParams(window.location.search)
    const fromSearch = this.parseBotId(searchParams.get("bot_id"))
    if (fromSearch) {
      return fromSearch
    }

    const hash = window.location.hash
    if (!hash) {
      return null
    }

    const hashContent = hash.startsWith("#") ? hash.slice(1) : hash
    const hashQueryIndex = hashContent.indexOf("?")
    if (hashQueryIndex !== -1) {
      const hashParams = new URLSearchParams(hashContent.slice(hashQueryIndex + 1))
      const fromHashQuery = this.parseBotId(hashParams.get("bot_id"))
      if (fromHashQuery) {
        return fromHashQuery
      }
    }

    const hashParams = new URLSearchParams(hashContent)
    return this.parseBotId(hashParams.get("bot_id"))
  }

  static getBotIdFromTelegram() {
    const tg = window.Telegram?.WebApp
    const startParam = tg?.initDataUnsafe?.start_param
    if (!startParam) {
      return null
    }

    const direct = this.parseBotId(startParam)
    if (direct) {
      return direct
    }

    const match = String(startParam).match(/(?:bot[_-]?id[=:]?)(\d+)/i)
    return match ? this.parseBotId(match[1]) : null
  }

  static getStoredBotId() {
    try {
      return this.parseBotId(sessionStorage.getItem(BOT_ID_STORAGE_KEY))
    } catch {
      return null
    }
  }

  static persistBotId(botId) {
    if (!botId) {
      return
    }

    try {
      sessionStorage.setItem(BOT_ID_STORAGE_KEY, String(botId))
    } catch {
      // sessionStorage может быть недоступен в некоторых webview
    }
  }

  static getBotId() {
    const botId =
      this.getBotIdFromUrl() ||
      this.getBotIdFromTelegram() ||
      this.getStoredBotId()

    if (botId) {
      this.persistBotId(botId)
    }

    return botId
  }
}
